<!-- StepSelection.vue -->
<template>
  <div class="modal_main_analysis">
    <div class="modal_main_analysis_head">
      <h1>Какой аудит вы хотите провести?</h1>
    </div>
    <div class="modal_main_analysis_content">
      <!-- Карточка 1 -->
      <div class="modal_main_analysis_card"
        :class="{ modal_main_analysis_card_active: localAnalysis[0] }"
        @click="selectOption(0)">
        <div class="modal_main_analysis_card_radio">
          <span v-if="localAnalysis[0]" class="radio-dot"></span>
        </div>
        <div class="modal_main_analysis_card_content">
          <div class="modal_main_analysis_card_content_head">
            Аудит регламента
          </div>
          <div class="modal_main_analysis_card_content_text">
            Проверка документа на соответствие стандартам регламентов
          </div>
        </div>
      </div>
      
      <!-- Карточка 2 -->
      <div class="modal_main_analysis_card"
        :class="{ modal_main_analysis_card_active: localAnalysis[1] }"
        @click="selectOption(1)">
        <div class="modal_main_analysis_card_radio">
          <span v-if="localAnalysis[1]" class="radio-dot"></span>
        </div>
        <div class="modal_main_analysis_card_content">
          <div class="modal_main_analysis_card_content_head">
            Аудит на соответствие другого документа
          </div>
          <div class="modal_main_analysis_card_content_text">
            Сравнение вашего документа с эталонным
          </div>
        </div>
      </div>
      
      <!-- Кнопка продолжения -->
      <div class="modal_main_load_content_btn" 
           style="cursor: pointer; margin-top: 32px;"
           @click="$emit('continue')"
           :class="{ 'disabled': !hasSelection }">
        Продолжить
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepSelection',
  props: {
    analysisCard: {
      type: Array,
      default: () => [false, false]
    }
  },
  emits: ['update:analysisCard', 'continue'],
  computed: {
    localAnalysis: {
      get() {
        return this.analysisCard
      },
      set(value) {
        this.$emit('update:analysisCard', value)
      }
    },
    hasSelection() {
      return this.localAnalysis[0] || this.localAnalysis[1]
    }
  },
  methods: {
    selectOption(index) {
      const newValue = [false, false]
      newValue[index] = true
      this.localAnalysis = newValue
    }
  }
}
</script>

<style scoped>
.modal_main_analysis {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modal_main_analysis_head {
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal_main_analysis_head h1 {
  font-weight: 600;
  color: #D9D9D9;
  max-width: 70%;
  font-size: 24px;
  margin: 0;
}

.modal_main_analysis_content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  width: 100%;
  align-items: center;
  height: 100%;
}

.modal_main_analysis_card {
  user-select: none;
  cursor: pointer;
  background: transparent;
  border: 1px solid #403F6D;
  max-width: 740px;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 32px;
  border-radius: 23px;
  width: 100%;
  gap: 32px;
  transition: all 0.3s;
}

.modal_main_analysis_card:hover {
  background: #ffffff0a;
}

.modal_main_analysis_card_active {
  border: 1px solid #FF00E1;
  background: #c572ba13;
}

.modal_main_analysis_card_radio {
  border: 2px solid #403F6D;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  min-width: 32px;
  position: relative;
}

.modal_main_analysis_card_active .modal_main_analysis_card_radio {
  border-color: #FF00E1;
}

.radio-dot {
  position: absolute;
  width: 20px;
  height: 20px;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  background: #FF00E1;
  transform: translate(-50%, -50%);
}

.modal_main_analysis_card_content {
  text-align: start;
}

.modal_main_analysis_card_content_head {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 32px;
  line-height: 120%;
  letter-spacing: -3%;
}

.modal_main_analysis_card_content_text {
  font-size: 18px;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -3%;
  opacity: 0.8;
}

.modal_main_load_content_btn {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
  padding: 18px 40px;
  background: #8A75FF;
  justify-content: center;
  border-radius: 24px;
  max-width: 740px;
  transition: opacity 0.3s;
  cursor: pointer;
}

.modal_main_load_content_btn:hover {
  opacity: 0.9;
}

.modal_main_load_content_btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}

@media (max-width: 580px) {
  .modal_main_analysis_card {
    gap: 16px;
    padding: 16px;
  }
  
  .modal_main_analysis_card_content_head {
    font-size: 18px;
    margin-bottom: 16px;
  }
  
  .modal_main_analysis_card_content_text {
    font-size: 14px;
  }
  
  .modal_main_analysis_head h1 {
    max-width: 90%;
    font-size: 20px;
  }
}
</style>